import { Box, BoxProps } from '@cmpsr/components';

export default function MainContent(props: BoxProps): React.ReactElement {
  return <Box as="main" flex="1" {...props} />;
}
